import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
//const baseURL = 'http://rutasmeigasservices.test/api/v1'; //local
//const baseURL = 'https://rutasmeigasservices.alvapy.com/api/v1'; //DEV
const baseURL = 'https://rutasmeigasservicespro.alvapy.com/api/v1'; //PROD

//const baseURL = 'http://127.0.0.1:8000/api/v1';//local Mac

axios.defaults.baseURL = baseURL;
Vue.use(VueAxios, axios);
